/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import classNames from 'classnames';
import reactUpdate from 'immutability-helper';
import React from 'react';
import isEqual from 'react-fast-compare';
import _ from 'underscore';

import * as benchlingUtil from 'BenchlingUtil';
import {Selector} from 'notebook/ELNConstants';
import SelectorDAO from 'notebook/plain-tables/selectors/SelectorDAO';
import {Table} from 'notebook/tables/TableConstants';
import Col from 'ui-library/bs/Col';
import FormGroup from 'ui-library/bs/FormGroup';
import FormInput from 'ui-library/bs/FormInput';
import Row from 'ui-library/bs/Row';
import TextArea from 'ui-library/bs/TextArea';
import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import Modal from 'ui-library/modals/Modal';

export interface ManageSelectorsModalProps {
  doneText?: string;
  initialSelectorId?: string;
  locked: boolean;
  parentType?: string;
  selectorsLink: {
    value: Array<any>;
    requestChange: (...args: Array<any>) => any;
    selectorUsageCounts?: any;
  };
  onRequestClose: (...args: Array<any>) => any;
}

class ManageSelectorsModal extends React.Component<ManageSelectorsModalProps> {
  static countSelectors(documentParts: Array<{table?: Table | null}>): Record<string, number> {
    const usageCounts: {[selectorId: string]: number} = {};
    // eslint-disable-next-line no-restricted-syntax
    for (const part of Array.from(_.filter(documentParts, (documentPart) => documentPart.table != null))) {
      for (const row of Array.from(part.table!.table)) {
        for (const cell of Array.from(row)) {
          const {selectorId} = cell;
          if (selectorId == null) {
            continue;
          }
          if (!usageCounts[selectorId]) {
            usageCounts[selectorId] = 0;
          }
          usageCounts[selectorId] += 1;
        }
      }
    }
    return usageCounts;
  }

  static defaultProps = {
    doneText: 'Done',
  };

  renderTitle = (): JSX.Element => {
    let title = `${this.props.locked ? 'View' : 'Manage'} selectors `;
    if (this.props.parentType) {
      title += `for ${this.props.parentType} `;
    }
    return <div>{title}</div>;
  };

  render(): JSX.Element {
    // Necessary to suppress event handling from mediocre's itemMouseDownHandler.
    return (
      <div
        onMouseDown={function (e: any): void {
          return e.stopPropagation();
        }}
      >
        <Modal
          title={this.renderTitle()}
          onRequestClose={this.props.onRequestClose}
          buttons={[{text: this.props.doneText, cancel: true}]}
        >
          <ManageSelectorsComponent
            initialSelectorId={this.props.initialSelectorId}
            locked={this.props.locked}
            parentType={this.props.parentType}
            selectorsLink={this.props.selectorsLink}
          />
        </Modal>
      </div>
    );
  }
}

interface ManageSelectorsComponentProps {
  initialSelectorId?: string;
  locked: boolean;
  parentType?: string;
  selectorsLink: {
    value: Array<any>;
    requestChange: (...args: Array<any>) => any;
    selectorUsageCounts?: any;
  };
}

type ManageSelectorsComponentState = any;

class ManageSelectorsComponent extends React.Component<
  ManageSelectorsComponentProps,
  ManageSelectorsComponentState
> {
  state: ManageSelectorsComponentState = {
    activeSelectorId:
      this.props.initialSelectorId ||
      (this.props.selectorsLink.value[0] != null ? this.props.selectorsLink.value[0].staticId : undefined),
  };

  UNSAFE_componentWillReceiveProps(nextProps: ManageSelectorsComponentProps): void {
    // When the user clicks "create a selector" from the set-selector modal (when no selectors
    // exist), we create a selector and then open this modal.
    // The newly created selector won't be active since getInitialState occurs before the prop
    // update.
    if (this.props.initialSelectorId == null && nextProps.initialSelectorId != null) {
      this.setState({activeSelectorId: nextProps.initialSelectorId});
    }
  }

  setActiveSelector = (activeSelector: any): void => {
    this.setState({activeSelectorId: activeSelector != null ? activeSelector.staticId : undefined});
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _updateSelectors = (newSelectors: any) => this.props.selectorsLink.requestChange(newSelectors);

  createSelector = (): void => {
    const newSelector = SelectorDAO.makeSelector('Untitled Selector');
    const newSelectors = reactUpdate(this.props.selectorsLink.value, {$push: [newSelector]});
    this._updateSelectors(newSelectors);
    this.setActiveSelector(newSelector);
  };

  updateSelector = (idx: any, newSelector: any): void => {
    const newSelectors = reactUpdate(this.props.selectorsLink.value, {$splice: [[idx, 1, newSelector]]});
    this._updateSelectors(newSelectors);
  };

  deleteSelector = (idx: any): void => {
    const selectors = this.props.selectorsLink.value;
    const newSelectors = reactUpdate(selectors, {$splice: [[idx, 1]]});
    this._updateSelectors(newSelectors);

    const newIdx = Math.min(newSelectors.length - 1, idx + 1);
    this.setActiveSelector(newSelectors[newIdx]);
  };

  renderSelectors = (): JSX.Element => (
    <ul className="list-group u-spacing-top">
      {(() => {
        const result = [];
        for (const selector of Array.from(this.props.selectorsLink.value)) {
          const count = this.props.selectorsLink.selectorUsageCounts[selector.staticId];
          const badgeVisible = count > 0;
          result.push(
            <a
              key={selector.staticId}
              className={classNames({
                'list-group-item': true,
                active: this.state.activeSelectorId === selector.staticId,
              })}
              onClick={this.setActiveSelector.bind(null, selector)}
            >
              {selector.name}
              {badgeVisible ? (
                <Tooltip
                  title={`Selector used in ${count} ${benchlingUtil.pluralize(count, 'cell')}`}
                  placement={TooltipPlacement.RIGHT}
                  container=".js-manage-selectors"
                  delay={0}
                >
                  <span className="badge">{count}</span>
                </Tooltip>
              ) : undefined}
            </a>
          );
        }
        return result;
      })()}
    </ul>
  );

  renderManageSelectors = (): JSX.Element => {
    const activeSelector = _.findWhere(this.props.selectorsLink.value, {
      staticId: this.state.activeSelectorId,
    });
    // eslint-disable-next-line no-restricted-syntax
    const activeSelectorIdx = _.indexOf(this.props.selectorsLink.value, activeSelector);

    return (
      <div>
        <Row className="js-manage-selectors">
          <Col sm={5}>
            {!this.props.locked ? (
              <Button
                buttonStyle={ButtonStyle.TERTIARY_GRAY}
                size={ButtonSize.SMALL}
                fullWidth={true}
                onClick={this.createSelector}
                text="New Selector"
              />
            ) : null}
            {this.renderSelectors()}
          </Col>
          <Col sm={7}>
            {activeSelector ? (
              <EditSelectorComponent
                locked={this.props.locked}
                selector={activeSelector}
                updateSelector={this.updateSelector.bind(null, activeSelectorIdx)}
                deleteSelector={this.deleteSelector.bind(null, activeSelectorIdx)}
              />
            ) : undefined}
          </Col>
        </Row>
      </div>
    );
  };

  renderNoSelectors = (): JSX.Element => (
    <div className="text-center">
      <h5 className="u-spacing-bottom">
        {`This ${
          this.props.parentType ? this.props.parentType.toLowerCase() : 'document'
        } doesn't have any selectors.`}
      </h5>
      {!this.props.locked && (
        <Button
          buttonStyle={ButtonStyle.TERTIARY_GRAY}
          size={ButtonSize.SMALL}
          onClick={this.createSelector}
          text="Create a selector"
        />
      )}
      <p className="u-spacing-top">Selectors let you define specific allowed values for a cell.</p>
    </div>
  );

  render(): JSX.Element {
    if (this.props.selectorsLink.value.length) {
      return this.renderManageSelectors();
    } else {
      return this.renderNoSelectors();
    }
  }
}

interface EditSelectorComponentProps {
  locked: boolean;
  selector: Selector;
  updateSelector: (...args: Array<any>) => any;
  deleteSelector: (...args: Array<any>) => any;
}

interface EditSelectorComponentState {
  name: string;
  options: Array<string>;
}

class EditSelectorComponent extends React.Component<EditSelectorComponentProps, EditSelectorComponentState> {
  state: EditSelectorComponentState = {
    name: this.props.selector.name,
    options: this.props.selector.options,
  };

  UNSAFE_componentWillReceiveProps(nextProps: EditSelectorComponentProps): void {
    if (nextProps.selector.staticId !== this.props.selector.staticId) {
      this.setState({
        name: nextProps.selector.name,
        options: nextProps.selector.options,
      });
    }
  }

  updateOptions = (e: any): void => {
    const newOptions = e.target.value.split('\n');
    this.setState({options: newOptions});
  };

  saveSelector = (): void => {
    const newSelector = reactUpdate(this.props.selector, {
      $merge: {
        // eslint-disable-next-line no-restricted-syntax
        options: _.filter(this.state.options, (option) => option.trim().length > 0),
        name: this.state.name,
      },
    });
    this.props.updateSelector(newSelector);
  };

  render(): JSX.Element {
    const textAreaChildren = this.state.options.join('\n');
    const selectorClean =
      this.state.name === this.props.selector.name &&
      isEqual(this.state.options, this.props.selector.options);

    // Right spacing gets right side of form to line up with Done button
    return (
      <div className="u-tiny-spacing-right">
        <FormGroup>
          <label>Selector name</label>
          <a className="text-danger u-no-text-decoration pull-right" onClick={this.props.deleteSelector}>
            <BenchlingIcon icon="trash-can" />
          </a>
          <FormInput
            placeholder="Selector name"
            readOnly={this.props.locked}
            value={this.state.name}
            onChange={(e: any) => {
              this.setState({name: e.target.value});
            }}
          />
        </FormGroup>
        <FormGroup>
          <label>Selector options</label>
          <TextArea
            placeholder={'Glycerol (8%)\nGlycerol (6%)\nYeast Extract (2%)\nSoytone (2%)'}
            readOnly={this.props.locked}
            value={textAreaChildren}
            onChange={this.updateOptions}
            rows={Math.max(12, this.state.options.length)}
          />
        </FormGroup>
        <FormGroup>
          <Button
            buttonStyle={ButtonStyle.PRIMARY}
            size={ButtonSize.SMALL}
            onClick={this.saveSelector}
            disabled={selectorClean}
            text="Save"
          />
        </FormGroup>
      </div>
    );
  }
}

export default ManageSelectorsModal;
